// extracted by mini-css-extract-plugin
export default {"imageWrapper":"TF-z","hovered":"UF-z","hoverImage":"VF-z","mainImage":"WF-z","imageNoBackground":"XF-z","fullSizeImage":"YF-z"};